<template>
  <div class="isotopeGrid">
    
    <div class="section1">
      <div class="title_wrapper">
        <p class="title">
          {{isotopeProps.title}}
        </p>
        <p class="subTitle">
          {{isotopeProps.desc}}
        </p>
      </div>
    </div>

    <div class="section2">
      <div class="isotopeWrapper">

        <div class="tags" v-if="isotopeProps.showTag">
          <div class="button-group">
            <button v-for="(val, key) in isotopeProps.option.getFilterData" class="button" :class="[key===isotopeProps.filterOption? 'is-checked' : '']" @click="filter(key)">{{key}}
            </button>
          </div>
        </div>

        <isotope v-if="isotopeProps.popup" ref="ist" :list="isotopeProps.list" id="root_isotope" class="isoDefault" :options='isotopeProps.option'>
          <div v-for="element in isotopeProps.list" v-on:click="showPopup(element.html)" :key="element.id">
            <picture class="visual" v-if="!!element.imgpath">
              <img :src="element.imgpath">
            </picture>
            <div class="item_container">
              <h1 v-if="element.cardname"><strong>{{element.cardname}}</strong></h1>
              <h1 v-else><strong>{{isotopeProps.cardname}}</strong></h1>
              <p>{{element.name}}</p>
            </div>
          </div>
        </isotope>

        <isotope v-else ref="ist" :list="isotopeProps.list" id="root_isotope" class="isoDefault" :options='isotopeProps.option'>
          <router-link v-for="element in isotopeProps.list" @click="isotopeProps.selected=element" :key="element.id" :to="element.link">
            <picture class="visual" v-if="!!element.imgpath">
              <img :src="element.imgpath">
            </picture>
            <div class="item_container">
              <h1 v-if="element.cardname"><strong>{{element.cardname}}</strong></h1>
              <h1 v-else><strong>{{isotopeProps.cardname}}</strong></h1>
              <p>{{element.name}}</p>
            </div>
          </router-link>
        </isotope>
        
      </div>
    </div>

    <div v-if="isotopeProps.popup" class="isotopePopup" :class="{active: isotopeProps.openPopup}">
      <div class="popupWrapper">
        <div class="popupInner">
          <div class="closeBtn">
            <img v-on:click="togglePopup()" src="../../assets/cross@2x.png">
          </div>
          <div class="popupContents" v-html="isotopeProps.popupContents"></div>
        </div>
      </div>
      <div class="popupBG" v-on:click="togglePopup()"></div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'isotopegrid',
  props: ['isotopeProps'],
  methods: {
    sort: function (key) {
      this.$refs.ist.sort(key)
    },
    filter: function (key) {
      this.$refs.ist.filter(key)
      this.isotopeProps.filterOption = key
    },
    changeLayout: function (key) {
      this.$refs.ist.layout(key)
    },
    showPopup: function (contentsHtml) {
      this.togglePopup()
      this.isotopeProps.popupContents = contentsHtml
    },
    togglePopup: function () {
      if (this.isotopeProps.openPopup) {
        this.isotopeProps.openPopup = false
      } else {
        this.isotopeProps.openPopup = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../../styles/_vars.sass"
@import "../../styles/_isotopeGrid.sass"

</style>



// WEBPACK FOOTER //
// isotopeGrid.vue?7ca2c270